import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { PURCHASE_STATUS } from '../../constant/constant';
import './style.scss';

const PurchaseCard = ({
  orderRef = '',
  status = PURCHASE_STATUS.UNPAID,
  host = { avatar: '', avatarBg: '', name: '', group: '' },
  meta = '',
  title = '',
  itemsCount = 0,
  statusText = '',
  isDisable = false,
}) => {
  const history = useHistory();
  const titleColor = isDisable ? '#888780' : '#009A97';
  const hostAvatarBg = isDisable ? '#B4B2A9' : (host.avatarBg || '#009A97');

  const handleViewOrder = () => {
    if (orderRef) {
      history.push(`/event/purchase-detail?ref=${orderRef}`);
    }
  };

  return (
    <div className={`pcard ps-${status} ${isDisable ? 'is-disabled' : ''}`} onClick={handleViewOrder}>
      <div className="pcard-head">
        <div className="pcard-host">
          <div className="avatar lg" style={{ background: hostAvatarBg, fontSize: '12px', overflow: 'hidden' }}>
            {host.photoUrl ? (
              <img
                src={host.photoUrl}
                alt={host.name}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              host.avatar || host.name?.charAt(0)?.toUpperCase()
            )}
          </div>
          <div>
            <div className="pcard-hname">{host.name}</div>
            <div className="pcard-hgrp">{host.group}</div>
          </div>
        </div>
        <div className="pcard-meta" dangerouslySetInnerHTML={{ __html: meta }} />
      </div>

      <div className="pcard-summary">
        <div className="pcard-title" style={{ color: titleColor }}>{title}</div>
        <div className="pcard-summary-right">
          <span className="pcard-icount">
            {itemsCount} {itemsCount === 1 ? 'item' : 'items'}
          </span>
        </div>
      </div>

      <div className="pcard-action">
        {status !== PURCHASE_STATUS.UNPAID && (
          <button
            className="view-order-btn"
            style={isDisable ? { color: '#B4B2A9' } : {}}
            onClick={handleViewOrder}
          >
            View order details
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
              <path d="M12 5l7 7-7 7" />
            </svg>
          </button>
        )}

        {status === PURCHASE_STATUS.UNPAID && (
          <button className="pcard-cta" onClick={handleViewOrder}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" />
              <line x1="1" y1="10" x2="23" y2="10" />
            </svg>
            Make payment
          </button>
        )}

        {status === PURCHASE_STATUS.READY && (
          <>
            <div className="pcard-status">
              <div className="pcard-sdot"></div>
              <span className="pcard-stxt">{statusText}</span>
            </div>
            <button className="pcard-cta" onClick={handleViewOrder}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Acknowledge collection
            </button>
          </>
        )}

        {(status === PURCHASE_STATUS.PENDING || status === PURCHASE_STATUS.FULFILL
          || status === PURCHASE_STATUS.COLLECTED || status === PURCHASE_STATUS.CANCEL
          || status === PURCHASE_STATUS.REFUND) && (
          <div className="pcard-status">
            <div className="pcard-sdot"></div>
            <span className="pcard-stxt">{statusText}</span>
          </div>
        )}
      </div>
    </div>
  );
};

PurchaseCard.propTypes = {
  orderRef: PropTypes.string,
  status: PropTypes.oneOf(Object.values(PURCHASE_STATUS)),
  host: PropTypes.shape({
    avatar: PropTypes.string,
    avatarBg: PropTypes.string,
    photoUrl: PropTypes.string,
    name: PropTypes.string,
    group: PropTypes.string,
  }),
  meta: PropTypes.string,
  title: PropTypes.string,
  itemsCount: PropTypes.number,
  statusText: PropTypes.string,
  isDisable: PropTypes.bool,
};

export default PurchaseCard;
